<div class="dashboard-container" [class.paddingLeft]="isSidebarExpanded">
  <!-- Background Design Elements -->
  <div class="background-design">
    <div class="bg-circle bg-circle-1"></div>
    <!-- <div class="bg-circle bg-circle-2"></div>
    <div class="bg-circle bg-circle-3"></div> -->
    <div class="bg-pattern"></div>
  </div>

  <!-- Header Section -->
  <div class="dashboard-header">
    <div class="header-left">
      <h1 class="fs-18 fw-500" style="margin-bottom: 3px;color: #0075C9;">Dashboard</h1>
      <p class="fs-13 gray-text">Manage and track your applicant registrations for insurance policies.</p>
    </div>
    <div class="header-right">
      <button class="primaryBtn" (click)="onAddApplicant()">
        Add New Applicant
      </button>
    </div>
  </div>

  <!-- First Row - Cards -->
  <div class="status-cards-grid">
    <div class="status-card animate-slide-right" *ngFor="let card of statusCards; let i = index"
      (mouseenter)="onCardHover(i)" (mouseleave)="onCardLeave()" (click)="onCardClick(i)">

      <div class="card-icon">
        <img [src]="card.svgIcon" [alt]="card.title" class="icon-svg" />
      </div>

      <div class="card-info">
        <h3 class="card-title">{{ card.title }}</h3>
        <p class="card-count">
          {{ card.count | countUp:card.trigger$:800 | async }}
        </p>
      </div>
    </div>
  </div>


  <div class="row no-gutters">
    <!-- Left: Latest Applicants (50%) -->
    <div class="col-md-6" style="padding:0 !important;">
      <div class="custom-card h-100">
        <div class="card-header">
          <div class="d-flex justify-content-between">
            <p class="mb-0 fs-13 fw-500">Latest Applicants</p>
            <p (click)="goToPatients()" class="see-all cursor-pointer">
              See all
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 2 16 16">
                <path fill="#0075C9"
                  d="m5.157 13.069l4.611-4.685a.546.546 0 0 0 0-.768L5.158 2.93a.55.55 0 0 1 0-.771a.53.53 0 0 1 .759 0l4.61 4.684a1.65 1.65 0 0 1 0 2.312l-4.61 4.684a.53.53 0 0 1-.76 0a.55.55 0 0 1 0-.771" />
              </svg>
            </p>
          </div>
        </div>
        <div class="left-panel mt-3">
          <ng-container *ngIf="patientsList && patientsList.length > 0; else noPatients">
            <ul class="patient-list">
              <li *ngFor="let patient of patientsList; let i = index" class="patient-item animate"
                (click)="onReqClick(i)">
                <div class="patient-avatar">
                  {{ patient.firstName | initials: patient.lastName}}
                </div>
                <div class="patient-info">
                  <h5 class="mb-1">{{ patient.firstName }} {{ patient.lastName }}</h5>
                  <p class="mb-0 text-muted">DOB: {{ patient.dateOfBirth }}</p>
                  <p class="mb-0 text-muted fs-11">
                    Requested on: {{ patient.createdOn | date: 'dd-MM-yyyy HH:mm' }}
                  </p>
                </div>
                <div class="patient-status">
                  <app-status-lables [status]="patient.status" [entityType]="enumEntityType.INSURER">
                  </app-status-lables>
                  <div class="last-updated text-muted fs-11 mt-1">
                    Last Updated: {{ patient.lastUpdatedOn | date: 'dd-MM-yyyy HH:mm' }}
                  </div>
                </div>
              </li>
            </ul>
          </ng-container>
          <ng-template #noPatients>
            <app-no-data-found></app-no-data-found>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- Right: Chart (50%) -->
    <div class="col-md-6" style="padding:0 !important;">
      <div class="custom-card h-100">
        <div class="card-header">
          <p class="fs-13 fw-500" style="margin:0">Last 6 Months Overview</p>
        </div>

        <div class="sleep-quality-container">
          <div class="sleep-chart-section">
            <div class="d-flex align-items-center" style="gap: 24px;">
              <div class="chart-wrapper" style="width:260px;height:260px;">
                <canvas baseChart [data]="chartData" [options]="chartOptions" [type]="chartType" class="chart-canvas"
                  style="display:block;width:100%;height:100%;">
                </canvas>
              </div>

              <ul class="custom-legend mb-0" style="list-style:none;padding:0;margin:0;">
                <li *ngFor="let item of legendItems" class="d-flex align-items-center mb-2" style="gap:8px;">
                  <span style="display:inline-block;width:10px;height:10px;border-radius:50%;"
                    [style.background]="item.color"></span>
                  <span class="fs-12" style="color:#555;">{{ item.label }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>


</div>